<template>
  <div class="gpt-editor-templateValueMap">
    <div v-if="templateValueMap" class="content">
        <el-form label-width="4em" label-suffix="：">
            <el-form-item v-for="(val, key) in templateValueMap" :key="key" :label="key">
                <el-input type="textarea" :rows="2" v-model="templateValueMap[key]" @change="saveLocal();update()"></el-input>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
    name: 'gpt-editor-templateValueMap',
    data () {
        let templateValueMap = null;
        return { templateValueMap };
    },
    props: {
        value: {
            type: Object,
            default: null
        },
        promptTemplate: {
            type: Object,
            default: null
        }
    },
    watch: {
        promptTemplate () {
            this.reset();
        }
    },
    async mounted () {
        this.showForm = this.show;
        this.reset();
    },
    methods: {
        /**
         * 重置
         */
        async reset () {
            if (!this.promptTemplate) {
                this.templateValueMap = null;
                return;
            }
            const local = this.loadLocal();
            const strs = this.extractTextFromBrackets(this.promptTemplate.content);
            if (!strs || !strs.length) {
                this.templateValueMap = null;
                return;
            }
            let map = {};
            strs.forEach(str => {
                map[str] = local[str] || '';
            });
            this.templateValueMap = map;
            this.update();
        },

        loadLocal () {
            if (!this.promptTemplate) return {};
            let ret = localStorage.getItem('templateValueMap-' + this.promptTemplate.code);
            if (ret) {
                return JSON.parse(ret);
            } else {
                return {};
            }
        },

        saveLocal () {
            if (!this.promptTemplate) return;
            if (!this.templateValueMap) return;
            localStorage.setItem('templateValueMap-' + this.promptTemplate.code, JSON.stringify(this.templateValueMap));
        },

        /**
         * 更新
         */
        async update () {
            this.$emit('update:value', this.templateValueMap);
        },

        extractTextFromBrackets (inputString) {
            const regex = /\{([A-Za-z]+)\}/g;
            const matches = [];
            let match;

            while ((match = regex.exec(inputString)) !== null) {
                matches.push(match[1]);
            }

            return matches;
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-editor-templateValueMap {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 1em;
    background: var(--page-bg-img);
    background-size: cover;
    .content {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #FFF;
        border-radius: 0.5em;
        padding: 1em;
        overflow: auto;
        .prompt-content {
            height: calc(100% - 22em);
            &::v-deep {
                .el-textarea__inner {
                    position: relative;
                    height: 100%;
                }
            }
        }
    }
    .footer {
        margin-top: 0.5em;
    }
    .rightplace {
        float: right;
    }

    .el-form {
        .el-form-item {
            .el-input-number{
                width: 110px;
                }
            .el-slider{
                padding-left: 20px;
                display:inline-block;
                vertical-align: bottom;
                width:calc(100% - 110px);
            }
        }
    }
}
</style>
